import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import TableContainer from '../../../Components/Common/TableContainer';
import {
    Type,
    Quantity,
    OrderValue,
    AvgPrice,
    Price,
    Status
} from './OrderCol';

const AllOrders = ({ orderList, total = 0, currentPage = 1, pageSize = 8, onChange }) => {
    const columns = useMemo(
        () => [
            {
                header: "orderId",
                accessorKey: "order_reference_id",
                enableColumnFilter: false,
                cell: (cell) => (
                    <>
                    <div className="d-flex align-items-center"> 
                        <Link to={"/order-detail?orderId="+cell.row.original.id} className="currency_name flex-grow-1 ms-2">{cell.getValue()}</Link>
                    </div>
                </>
                ),
            },
            {
                header: "created_at",
                accessorKey: "created_at",
                enableColumnFilter: false,
                cell: (cell) => {
                    const date = new Date(cell.getValue());
                    return (
                        <>
                            {date.toLocaleDateString()}{" "}
                            <small className="text-muted">{date.toLocaleTimeString()}</small>
                        </>
                    );
                },
            },
            {
                header: "discount",
                accessorKey: "discount",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <span>$ {cell.getValue()}</span>;
                },
            },
            {
                header: "shipping Charge",
                accessorKey: "delivery_fee",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <span>$ {cell.getValue()}</span>;
                },
            },
            {
                header: "Tax",
                accessorKey: "applied_tax",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <span>$ {cell.getValue()}</span>;
                },
            },
            {
                header: "Total",
                accessorKey: "total_price",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <span>$ {cell.getValue()}</span>;
                },
            }, 
            {
                header: "Status",
                accessorKey: "status",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <Status {...cell} />;
                },
            },
        ],
        []
    );
    return (
        <React.Fragment>
            <Col lg={12}>
                <Card>
                    <CardHeader className="d-flex align-items-center border-0">
                        <h5 className="card-title mb-0 flex-grow-1">All Orders</h5>
                        
                    </CardHeader>
                    <CardBody>
                        <TableContainer
                            columns={columns}
                            data={(orderList || [])}
                            total={total || (orderList || []).length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onChange={onChange}
                            isGlobalFilter={true}
                            isAddUserList={false}
                            customPageSize={pageSize}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-1"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light text-muted"
                            isCryptoOrdersFilter={true}
                            SearchPlaceholder='Search for orders'
                        />
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default AllOrders;